"use client";

import { PaymentMethodList, TitleH2 } from "@/components/shared/public";
import type { CatalogPaymentMethod } from "@/lib/api/catalog";
import { useTranslations } from "next-intl";

interface PaymentMethodsProps {
  /**
   * Catalog payment methods fetched at the page level. Defaults to `[]` so
   * the section renders nothing when the catalog is empty (e.g. backend not
   * yet live). Once the API returns methods with `logos: ["paypal", ...]`
   * the brand logos will appear automatically through PaymentMethodList.
   */
  methods?: CatalogPaymentMethod[];
}

const PaymentMethods = ({ methods = [] }: PaymentMethodsProps) => {
  const t = useTranslations("common");

  if (methods.length === 0) {
    return null;
  }

  return (
    <div
      id="zahlungsmethoden"
      className="relative flex scroll-mt-28 flex-col items-center justify-center gap-8"
    >
      <span
        id="zahlungsarten"
        className="absolute -top-28"
        aria-hidden="true"
      />
      <TitleH2 title={t("paymentMethods")} />
      <PaymentMethodList methods={methods} />
    </div>
  );
};

export default PaymentMethods;
